import event from '../../../event'
import API from '../../../api/endpoints.js'
import Composite from '../../../Composite.js'
import { transformQueryString } from '../../helpers/RouteHash'
import IEHackMixin from '../../helpers/IEHackMixin'

export default {
  mixins: [IEHackMixin],
  methods: {
    multiSave ({data}) {
      event.$emit('loading-on', { title: 'Uploading' })
      this.$http.post(API.BATCH_CREATE_ADMIN_ENTITY(this.entityName), data)
      .then(() => {
        event.$emit('toast', { type: 'success', message: 'All rows successfully uploaded' })
      }).catch(err => {
        console.log(err)
        event.$emit('toast', { type: 'warning', message: 'An error occured uploading some rows; please check your document for create layout' })
      }).then(() => {
        event.$emit('loading-off', {})
        event.$emit('update-entity-data', {})
      })
    },
    goToNewEntityScreen () {
      if (!this.newEntityScreen) {
        window.console.warn(`If you can view this message, Admin Screen component '${this.$options.name}' has not set the newEntityScreen data member`)
      } else {
        this.$emit('clear-screen', {})
        this.$router.push({name: this.newEntityScreen})
      }
    },
    search ({search}) {
      if (!this.searchEntityScreen) {
        window.console.warn(`If you can view this message, Admin Screen component '${this.$options.name}' has not set the searchEntityScreen data member`)
      } else {
        this.$router.push({ name: this.searchEntityScreen, query: { [btoa('quick-search')]: btoa(search) } })
      }
    },
    openFilter () {
      if (!this.filterName || !this.filterEventName) {
        window.console.warn(`If you can view this message, Admin Screen component '${this.$options.name}' has not set the filterName and/or filterEventName data member`)
      } else {
        event.$emit('right-open', { callerId: this._uid, component: this.filterName, data: {}, event: this.filterEventName })
      }
    },
    transformFilterRequestData (data) {
      return transformQueryString(data)
    },
    respondToFilterRequest (data) {
      if (!this.searchEntityScreen) {
        window.console.warn(`If you can view this message, Admin Screen component '${this.$options.name}' has not set the searchEntityScreen data member`)
      } else {
        let queryParams = typeof this.transformFilterRequest !== 'undefined' && this.transformFilterRequest ? this.transformFilterRequestData(data) : data
        this.$router.push({ name: this.searchEntityScreen, query: { [btoa('search')]: btoa(JSON.stringify(queryParams)) } })
      }
    }
  },
  mounted () {
    if (!this.filterEventName) {
      window.console.warn(`If you can view this message, Admin Screen component '${this.$options.name}' has not set the filterEventName data member`)
    } else {
      event.$on(this.filterEventName, this.respondToFilterRequest)
    }
  },
  beforeDestroy () {
    if (!this.filterEventName) {
      window.console.warn(`If you can view this message, Admin Screen component '${this.$options.name}' has not set the filterEventName data member`)
    } else {
      event.$off(this.filterEventName, this.respondToFilterRequest)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/mixins/AdminScreenMixin.js